import { useNavigate } from 'react-router';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  RoleBadge,
} from '@repo-manager/ui';

import { useSession, useSupabase } from '../lib/supabase-context';

export function SettingsPage() {
  const { profile, user } = useSession();
  const supabase = useSupabase();
  const navigate = useNavigate();

  async function signOut() {
    await supabase.auth.signOut();
    navigate('/login', { replace: true });
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>
      <Card>
        <CardHeader>
          <CardTitle>Account</CardTitle>
          <CardDescription>Your Supabase auth identity and RLS role.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="grid grid-cols-[120px_1fr] gap-x-4 gap-y-2 text-sm">
            <div className="text-muted-foreground">Email</div>
            <div>{profile?.email ?? user?.email ?? '—'}</div>
            <div className="text-muted-foreground">User ID</div>
            <code className="rounded bg-muted px-2 py-0.5 text-xs">{user?.id ?? '—'}</code>
            <div className="text-muted-foreground">Role</div>
            <div>{profile ? <RoleBadge role={profile.role} /> : '—'}</div>
          </div>
          <div className="pt-4">
            <Button variant="outline" onClick={() => void signOut()}>
              Sign out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
